<template>
  <div>
    <div class="subtitle">
      {{ $t("walletVerification.subtitle_14") }}
    </div>
    <div class="subtitle">
      {{ $t(`walletVerification.subtitle_15`, { platform }) }}
    </div>

    <div class="d-flex align-items-center mt-4">
      <AuButton
        center
        width="200px"
        @click="$emit('gotoPage', isIssuer ? 'buy form' : 'projects')"
      >
        {{ leftText }}
      </AuButton>
      <AuButton
        class="ms-2"
        center
        type="primary"
        width="200px"
        @click="$emit('gotoCreate')"
      >
        {{ rightText }}
      </AuButton>
    </div>
  </div>
</template>

<script>
import AuButton from "@/components/extended/AuButton.vue";

export default {
  name: "VerificationSuccess",
  components: { AuButton },
  props: {
    platform: {
      type: String,
      default: ""
    },
    leftText: {
      type: String,
      default: ""
    },
    rightText: {
      type: String,
      default: ""
    },
    isIssuer: Boolean
  }
};
</script>

